import { Box, Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useGetWebhookSubscriptionsForUserQuery } from './webhooks.gql.generated';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';

// Fragments
const RouteBase = () => {
  const { data, loading, error } = useGetWebhookSubscriptionsForUserQuery();
  if (loading || !data) {
    return <Skeleton height="600px" data-testid="settings-route-loading" />;
  }
  if (error) throw error;
  if (data.webhookSubscriptionsForUser.length === 0) {
    return (
      <Box>
        If you would like to integrate a webhook, please contact
        support@finleycms.com
      </Box>
    );
  }
  return (
    <Box>
      {data.webhookSubscriptionsForUser.map((webhookSubscription) => (
        <Box key={webhookSubscription.svixApplicationId} mb="15px">
          <iframe
            title="svix-iframe"
            src={webhookSubscription.svixDashboardUrl}
            style={{ width: '100%', height: '650px', border: 'none' }}
            allow="clipboard-write"
            loading="lazy"
          />
        </Box>
      ))}
    </Box>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
